import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { GusCompany } from '@/organization/organization/organization.model';

@Injectable({
	providedIn: 'root',
})
export class OrganizationGusApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getCompany(nip: string): Observable<GusCompany> {
		return this.httpClient.get<GusCompany>(`${this.apiUrl}/nip/${encodeURIComponent(nip)}/`);
	}
}
